import { useAjax, useMzMutation } from "@harea/component";

export const useValidateBulkTimeoffCreationMutation = (config?: any) => {
  const ajax = useAjax();
  return useMzMutation(async (data: { ids: number[] }) => {
    try {
      return await ajax.send({
        type: "POST",
        content_type: "application/json",
        url: `project/dayoff/validate`,
        data: { ids: data.ids.map(id => id.toString()) },
      });
    } catch (err: any) {
      if (err?.response && typeof err.response === 'string') {
        try { err.response = JSON.parse(err.response); } catch { /* keep as-is */ }
      }
      throw err;
    }
  },
    config ?? { error_message: false },
  );
};